import React from 'react'
import DriverLayout from '../../layouts/DriverLayout'
import Transactions from '../../components/Transactions'

const DriverTransaction = () => {
  return (
    <DriverLayout>
    <Transactions />
    </DriverLayout>
  )
}

export default DriverTransaction
